import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { Button } from 'components/Button';
import { useOfficeOrderPayment } from './useOfficeOrderPayment';

import './index.sass';

const { block } = bem('pay-button');
const PayButton = ({order}) => {

    const { pay, disabled } = useOfficeOrderPayment({ order });

    return (
        <div className={block()} onClick={pay}>
            <Button mod={'gold'} disabled={disabled}><Text>Оплатить</Text></Button>
        </div>
    )
}

export default PayButton;
